import { Affectation, Client, Criterion } from './client';
import { LocaleEnum } from './locale';
import { AuthorisationRight } from './authorisation-rights.const';

export class User {
  id: number;
  name?: string;
  active: boolean;
  valid: boolean;
  locale: LocaleEnum;
  country?: string;
  type: UserTypes;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  access: { 'back-office': string; 'front-dynamic': string };
  roles: string[];
  client?: Client; // only filled for api/me
  affectations?: Affectation[];
  criteria?: Criterion[];
  email: string;
  identifier: string;
  firstname: string;
  lastname: string;
  createdAt: Date;
  updatedAt: Date;
  lastLogin: Date;
  temporaryPassword?: boolean;
  matriculeRh?: string;
  matriculeAd?: string;
  admitted?: Date;
  manager?: User;
  isImpersonnated?: boolean;
  hasAcceptedCgu: boolean;
  trainerMeans: TrainerMean[];

  constructor(user?: User) {
    this.id = user?.id;
    this.name = user?.name;
    this.active = user?.active ?? false;
    this.valid = user?.valid;
    this.locale = user?.locale;
    this.country = user?.country;
    this.type = user?.type;
    this.access = user?.access;
    this.roles = user?.roles || [];
    this.client = new Client(user?.client);
    this.client = new Client(user?.client);
    this.email = user?.email;
    this.identifier = user?.identifier;
    this.temporaryPassword = user?.temporaryPassword;
    this.firstname = user?.firstname;
    this.lastname = user?.lastname;
    this.matriculeRh = user?.matriculeRh;
    this.matriculeAd = user?.matriculeAd;
    this.admitted = user?.admitted ? new Date(user.admitted) : null;
    this.manager = user?.manager;
    this.isImpersonnated = user?.isImpersonnated;
    this.hasAcceptedCgu = user?.hasAcceptedCgu ?? false;
    this.trainerMeans = user?.trainerMeans;

    this.createdAt = user?.createdAt ? new Date(user.createdAt) : null;
    this.updatedAt = user?.updatedAt ? new Date(user.updatedAt) : null;
    this.lastLogin = user?.lastLogin ? new Date(user.lastLogin) : null;
  }
}

export interface TrainerMean {
  meanName: string;
  meanSlug: string;
  sessionDroit: ETrainerRights;
}

export enum ETrainerRights {
  WRITE = 'mean-trainer-right-write',
  READ = 'mean-trainer-right-read',
}

export type UserEdit = Pick<
  User,
  | 'email'
  | 'firstname'
  | 'lastname'
  | 'locale'
  | 'admitted'
  | 'type'
  | 'manager'
  | 'roles'
  | 'matriculeRh'
  | 'matriculeAd'
  | 'hasAcceptedCgu'
>;

export type ClientUsers = Pick<User, 'id' | 'firstname' | 'lastname' | 'email' | 'identifier'>;

export enum UserTypes {
  ADMIN_SUP = 'ADMIN++',
  ADMIN = 'ADMIN',
  FORMATEUR = 'FORMATEUR',
  MANAGER = 'MANAGER',
  APPRENANT = 'APPRENANT',
  ANIMATEUR = 'ANIMATEUR',
}
export interface TrainerRightsForAutorisationService {
  right: AuthorisationRight;
  data?: Record<string, unknown>;
}

export interface TrainerRightsForAutorisationDirective {
  rights: AuthorisationRight[];
  data?: Record<string, unknown>;
}

export function formatTrainerRight(
  trainerMean: TrainerMean[],
  trainerRight: ETrainerRights,
  meanSlug: string,
): boolean {
  const targettedMean = trainerMean.find(tm => tm.meanSlug === meanSlug);
  if (targettedMean.sessionDroit === trainerRight) {
    return true;
  }
  return targettedMean.sessionDroit === ETrainerRights.WRITE;
}
